"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var BonusTournamentAmountsEditor_1 = require("./BonusTournamentAmountsEditor");
var BonusTournamentAmountsList_1 = require("./BonusTournamentAmountsList");
var BonusTournamentAmounts = /** @class */ (function (_super) {
    __extends(BonusTournamentAmounts, _super);
    function BonusTournamentAmounts(props) {
        return _super.call(this, props) || this;
    }
    BonusTournamentAmounts.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AC = this.props.listAppCurrency.Subscribe("*", function (id, data) {
            _this.setState({ availCurrency: data.data });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            availCurrency: []
        }, function () {
            _this.props.listAppCurrency.LoadData();
        });
        this.props.state.setExtBreadCrumbPath(["Турниры", "Суммы турниров"]);
    };
    BonusTournamentAmounts.prototype.componentWillUnmount = function () {
        this.props.listAppCurrency.UnSubscribe(this.SID_AC);
    };
    BonusTournamentAmounts.prototype.onGoBackToTopPageClick = function () {
        if (this.props.onGoBackClick) {
            this.props.onGoBackClick();
        }
    };
    BonusTournamentAmounts.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    BonusTournamentAmounts.prototype.onEditClick = function (item) {
        this.setState({ edit_mode: "EDIT", record: item });
    };
    BonusTournamentAmounts.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    BonusTournamentAmounts.prototype.getBrandCountriesRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(BonusTournamentAmountsEditor_1.default, { state: this.props.state, data: this.props.dataAmounts, rootRecord: this.props.record, onGoBack: this.onGoBackClick.bind(this), availCurrency: this.state.availCurrency, record: null }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(BonusTournamentAmountsEditor_1.default, { state: this.props.state, data: this.props.dataAmounts, rootRecord: this.props.record, onGoBack: this.onGoBackClick.bind(this), availCurrency: this.state.availCurrency, record: this.state.record }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(BonusTournamentAmountsList_1.default, { state: this.props.state, data: this.props.dataAmounts, rootRecord: this.props.record, onGoBackClick: this.onGoBackToTopPageClick.bind(this), onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this) }));
        }
    };
    BonusTournamentAmounts.prototype.render = function () {
        return (React.createElement("div", null, this.getBrandCountriesRenderObject()));
    };
    return BonusTournamentAmounts;
}(React.Component));
exports.default = BonusTournamentAmounts;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_tournament/ui/component/options/amounts/BonusTournamentAmounts.tsx
// module id = 2505
// module chunks = 0